import { SVGProps, Ref, forwardRef } from 'react';

export const PenHyperstarFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path d="M12.574 7.565 4.64 15.5H.5v-4.14l7.935-7.934z" fill="currentColor" />
                <path d="M10.503 1.357a2.927 2.927 0 0 1 4.14 4.14l-1.078 1.078-4.14-4.14z" fill="currentColor" />
                <path
                    d="M3 .5A9.5 9.5 0 0 0 5.5 3 9.5 9.5 0 0 0 3 5.5 9.5 9.5 0 0 0 .5 3 9.5 9.5 0 0 0 3 .5"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
PenHyperstarFilledSize16Glyph.displayName = 'PenHyperstarFilledSize16Glyph';
